



















import { Component, Vue, Prop } from 'vue-property-decorator'
import OzDrawerModal from 'library/v4/components/OzDrawerModal.vue'
import OzCenterModal from 'library/v4/components/OzCenterModal.vue'
/**
 * Screen size aware drawer modal that renders OzDrawerModal on phone and OzCenterModal on desktop. Used in Content picker.
 */
@Component({ components: { OzDrawerModal, OzCenterModal } })
export default class OzScreenSizeAwareCenterModal extends Vue {
  @Prop({ default: false }) isPhone!: boolean
}
